


// Utilidad: arma URL absoluta sin barras duplicadas ni finales
import { ImageInfo } from '@app-types/commons/images.types.ts';
import { getApiBaseUrl } from '@tools/components/ImageManager.tsx';

// CONSTANTES
export const IMG_NOT_FOUND = "https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png"

export const normalizeBase = (url: string) => url.replace(/\/+$/, '');
export const buildUrlFactory = (apiBase: string) => (path?: string | null) => {
  if (!path) return undefined;
  if (/^https?:\/\//i.test(path)) return path;                 // ya es absoluta
  return `${normalizeBase(apiBase)}/${String(path).replace(/^\/+/, '')}`;
};

export const buildUrl = buildUrlFactory(getApiBaseUrl());

export const getImageUrl = (
  image?: ImageInfo | string | null,
): { srcDefault: string; srcSet?: string } => {
  const toUrl = (raw?: string | null) => (raw ? buildUrl(raw) : undefined);

  if (!image) {
    return { srcDefault: IMG_NOT_FOUND };
  }

  if (typeof image === 'string') {
    const srcDefault = toUrl(image) ?? IMG_NOT_FOUND;
    return { srcDefault };
  }

  const defaultCandidate =
    image.thumbnails?.default ??
    image.thumbnails?.urls?.small ??
    image.file_path_small ??
    image.file_path_medium ??
    image.file_path_large;

  const srcDefault = toUrl(defaultCandidate) ?? IMG_NOT_FOUND;

  const srcSetStr = (
    [
      [image.thumbnails?.urls?.small ?? image.file_path_small, '480w'],
      [image.thumbnails?.urls?.medium ?? image.file_path_medium, '960w'],
      [image.thumbnails?.urls?.large ?? image.file_path_large, '1440w'],
    ] as Array<[string | null | undefined, string]>
  )
    .map(([raw, size]) => {
      const url = toUrl(raw);
      return url ? `${url} ${size}` : null;
    })
    .filter((entry): entry is string => Boolean(entry))
    .join(', ');

  return { srcDefault, srcSet: srcSetStr || undefined };
};